// extracted by mini-css-extract-plugin
export default {"logobarber":"Inicio_logobarber__SqI2Z"};